export enum MapObjectType {
    Object = 'object',
    Route = 'route',
}
